"use client";

// Shown on snapshot-backed stats surfaces while the backend rebuilds its
// stats snapshot (right after a deploy or a snapshot version bump). The
// pages would otherwise render empty tables and charts, which reads as
// "the site lost all its data". Polls /api/runs/snapshot-status once a
// minute and removes itself when the snapshot lands.
import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useT } from "@/lib/i18n";
const API = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000";
export default function StatsRebuildingNotice() {
  const $ = _c(11);
  const t = useT();
  const [building, setBuilding] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let active = true;
      let timer = null;
      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };
      const check = () => {
        if (document.hidden) {
          return;
        }
        fetch(`${API}/api/runs/snapshot-status`).then(_temp).then(s => {
          if (!active || !s) {
            return;
          }
          const b = Boolean(s.building);
          setBuilding(b);
          if (!b) {
            stop();
          }
        }).catch(_temp2);
      };
      check();
      timer = setInterval(check, 60000);
      return () => {
        active = false;
        stop();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!building) {
    return null;
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("Heads up");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="font-semibold text-warning mr-2">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("Stats are rebuilding after an update. Charts, metrics, and scores usually fill back in within 15 minutes; no data is lost.");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="rounded-lg border border-warning/40 bg-warning/10 px-4 py-2.5 mb-4 text-sm text-[var(--text-secondary)]">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2() {}
function _temp(r) {
  return r.ok ? r.json() : null;
}